import { FormGroupBulletList } from '@frontend/components/pages/episodeCategory/customControls/hearingLoss/hearingLossComponents/FormGroupBulletList';

export function HearingLossAudiologistConsultBijgevoegdeInformatie({ isFollowUp }: { readonly isFollowUp: boolean }) {
    const items = ['Audiologisch consult', 'Audiologisch onderzoek'];
    if (isFollowUp) {
        items.unshift('Audiologisch vervolgconsult');
    }

    return (
        <FormGroupBulletList
            items={items}
            label="Bijgevoegde informatie"
        />
    );
}
